import { ANALYSIS_SAMPLE_RATE } from '@/core/analysis/params';

/**
 * Decodes a file with the browser's decoder. decodeAudioData detaches the buffer it is given,
 * so this passes a copy and leaves `data` usable (e.g. for hashing).
 */
export async function decodeAudio(
  context: BaseAudioContext,
  data: ArrayBuffer,
): Promise<AudioBuffer> {
  return context.decodeAudioData(data.slice(0));
}

/**
 * Mono analysis input at ANALYSIS_SAMPLE_RATE, rendered with OfflineAudioContext (which also
 * down-mixes channels). Runs on the main thread: OfflineAudioContext isn't available in workers.
 */
export async function makeAnalysisInput(buffer: AudioBuffer): Promise<Float32Array> {
  const length = Math.max(1, Math.ceil(buffer.duration * ANALYSIS_SAMPLE_RATE));
  const offline = new OfflineAudioContext(1, length, ANALYSIS_SAMPLE_RATE);
  const source = offline.createBufferSource();
  source.buffer = buffer;
  source.connect(offline.destination);
  source.start();
  const rendered = await offline.startRendering();
  return rendered.getChannelData(0);
}
